import {
    FETCH_ALL_PERSONS,
    QUERY_CHANGE,
    FILTER_CHANGE,
    IS_LOADING,
    FETCH_MORE_PERSONS,
    TOGGLE_GROUP_MODAL_MENU,
    TOGGLE_MOBILE_MENU,
    LINKEDIN_TOKEN_VALIDATED,
    UPDATE_EXTERNAL_IDS,
    UPDATE_ME,
    FILTER_CLEAR_ALL,
    UPDATE_PERSONS
} from '../constants/ActionTypes';
import * as ApiUtils from '../views/reactViews/ApiUtil';
import { getAccessToken } from '../AuthToken';

function loadingAction(isLoading) {
    return {
        type: IS_LOADING,
        isLoading: isLoading
    };
}

function toggleMenuAction() {
    return {
        type: TOGGLE_GROUP_MODAL_MENU
    };
}

function toggleMobileMenuAction() {
    return {
        type: TOGGLE_MOBILE_MENU
    };
}

function filterClearAllAction() {
    return {
        type: FILTER_CLEAR_ALL
    };
}

function fetchAllPersonsAction(response) {
    return {
        type: FETCH_ALL_PERSONS,
        response
    };
}

function updatePersonsAction(response) {
    return {
        type: UPDATE_PERSONS,
        response
    };
}

function fetchMorePersonsAction(response) {
    return {
        type: FETCH_MORE_PERSONS,
        response
    };
}

function queryChangedAction(query) {
    return {
        type: QUERY_CHANGE,
        query
    };
}

function filterChangedAction(query) {
    return {
        type: FILTER_CHANGE,
        query
    };
}

function linkedInTokenValidatedAction(isValid) {
    return {
        type: LINKEDIN_TOKEN_VALIDATED,
        isValid
    };
}

function updateExternalIds(provider, id) {
    return {
        type: UPDATE_EXTERNAL_IDS,
        provider,
        id
    };
}

function updateMeAction(me) {
    return {
        type: UPDATE_ME,
        me
    };
}

function filterClearAll() {
    return (dispatch, getState) => {
        dispatch(filterClearAllAction());
    };
}

function updateMe(me) {
    return (dispatch, getState) => {
        dispatch(updateMeAction(me));
    };
}

export const getMeAction = () => async(dispatch, getState) => {
    try {
        const state = getState();
        const { meReducer: { me: { id: userId } } } = state;
        const bizzaboToken = getAccessToken();
        if (!userId && bizzaboToken) {
            const me = await ApiUtils.getUser();
            dispatch(updateMeAction({ ...me, isJoined: true }));
            return me;
        }
    } catch {
        return;
    }
};

export const checkIfInCommunityAction = () => async(dispatch, getState) => {
    try {
        const bizzaboToken = getAccessToken();
        if (!bizzaboToken) {
            return;
        }
        const state = getState();
        const { eventReducer: { event: { id: eventId }} } = state;
        const { joined: isJoined } = await ApiUtils.checkIfInCommunity(eventId);
        dispatch(updateMeAction({ isJoined }));
    } catch {
        return;
    }
};

function fetchAllPersons(options) {
    return (dispatch, getState) => {
        dispatch(queryChanged({offset: 0}));
        options.search = Object.assign({}, getState().queryReducer.search, {
            attributes: getState().queryReducer.attributeSelected
        });
        options.success = function(response) {
            dispatch(fetchAllPersonsAction(response));
        };
        return ApiUtils.getPersons(options);
    };
}

function fetchMorePersons(options) {
    return (dispatch, getState) => {
        dispatch(loadingChanged(true));
        options.search = Object.assign({}, options.search, {
            attributes: getState().queryReducer.attributeSelected
        });
        options.success = function(response) {
            dispatch(fetchMorePersonsAction(response));
            dispatch(loadingChanged(false));
        };
        options.error = function(response) {
            dispatch(loadingChanged(false));
        };
        return ApiUtils.getPersons(options);
    };
}

function queryChanged(query) {
    return (dispatch, getState) => dispatch(queryChangedAction(query));
}

function filterChanged(query) {
    return (dispatch, getState) => dispatch(filterChangedAction(query));
}


function loadingChanged(isLoading) {
    return (dispatch, getState) => dispatch(loadingAction(isLoading));
}

function toggleMenuChanged() {
    return (dispatch, getState) => dispatch(toggleMenuAction());
}

function toggleMobileMenuChanged() {
    return (dispatch, getState) => dispatch(toggleMobileMenuAction());
}

function validateLinkedInToken(options = {}) {
    return (dispatch, getState) => {
        const linkedInId = getState().meReducer.me.linkedInId;
        if (!linkedInId) {
            dispatch(linkedInTokenValidatedAction(false));
            return;
        }
        options.success = function(response) {
            var isValid = !!(response && response.id);
            dispatch(linkedInTokenValidatedAction(isValid));
        };
        return ApiUtils.validateLinkedInToken(options);
    };
}

export {
    fetchAllPersons,
    queryChanged,
    filterChanged,
    loadingChanged,
    toggleMenuChanged,
    toggleMobileMenuChanged,
    fetchMorePersons,
    validateLinkedInToken,
    updateExternalIds,
    updateMe,
    filterClearAll,
    fetchAllPersonsAction,
    fetchMorePersonsAction,
    updatePersonsAction
};
